// Static option lists shared by the address / boat cards. Pulled out of the
// component data() so they live in one place and are imported where used.

export const stateOptions = [
  {
    text: "Alabama",
    value: "AL",
  },
  {
    text: "Alaska",
    value: "AK",
  },
  {
    text: "Arizona",
    value: "AZ",
  },
  {
    text: "Arkansas",
    value: "AR",
  },
  {
    text: "California",
    value: "CA",
  },
  {
    text: "Colorado",
    value: "CO",
  },
  {
    text: "Connecticut",
    value: "CT",
  },
  {
    text: "Delaware",
    value: "DE",
  },
  {
    text: "District Of Columbia",
    value: "DC",
  },
  {
    text: "Florida",
    value: "FL",
  },
  {
    text: "Georgia",
    value: "GA",
  },
  {
    text: "Hawaii",
    value: "HI",
  },
  {
    text: "Idaho",
    value: "ID",
  },
  {
    text: "Illinois",
    value: "IL",
  },
  {
    text: "Indiana",
    value: "IN",
  },
  {
    text: "Iowa",
    value: "IA",
  },
  {
    text: "Kansas",
    value: "KS",
  },
  {
    text: "Kentucky",
    value: "KY",
  },
  {
    text: "Louisiana",
    value: "LA",
  },
  {
    text: "Maine",
    value: "ME",
  },
  {
    text: "Maryland",
    value: "MD",
  },
  {
    text: "Massachusetts",
    value: "MA",
  },
  {
    text: "Michigan",
    value: "MI",
  },
  {
    text: "Minnesota",
    value: "MN",
  },
  {
    text: "Mississippi",
    value: "MS",
  },
  {
    text: "Missouri",
    value: "MO",
  },
  {
    text: "Montana",
    value: "MT",
  },
  {
    text: "Nebraska",
    value: "NE",
  },
  {
    text: "Nevada",
    value: "NV",
  },
  {
    text: "New Hampshire",
    value: "NH",
  },
  {
    text: "New Jersey",
    value: "NJ",
  },
  {
    text: "New Mexico",
    value: "NM",
  },
  {
    text: "New York",
    value: "NY",
  },
  {
    text: "North Carolina",
    value: "NC",
  },
  {
    text: "North Dakota",
    value: "ND",
  },
  {
    text: "Ohio",
    value: "OH",
  },
  {
    text: "Oklahoma",
    value: "OK",
  },
  {
    text: "Oregon",
    value: "OR",
  },
  {
    text: "Pennsylvania",
    value: "PA",
  },
  {
    text: "Puerto Rico",
    value: "PR",
  },
  {
    text: "Rhode Island",
    value: "RI",
  },
  {
    text: "South Carolina",
    value: "SC",
  },
  {
    text: "South Dakota",
    value: "SD",
  },
  {
    text: "Tennessee",
    value: "TN",
  },
  {
    text: "Texas",
    value: "TX",
  },
  {
    text: "Utah",
    value: "UT",
  },
  {
    text: "Vermont",
    value: "VT",
  },
  {
    text: "Virginia",
    value: "VA",
  },
  {
    text: "Washington",
    value: "WA",
  },
  {
    text: "West Virginia",
    value: "WV",
  },
  {
    text: "Wisconsin",
    value: "WI",
  },
  {
    text: "Wyoming",
    value: "WY",
  },
];

export const countryOptions = [
  { value: "United States", text: "United States" },
  { value: "Canada", text: "Canada" },
];

// Salesforce holds whatever was typed into the country field over the years:
// "US", "USA", "UNITED STATES", "united states". None of those match an option
// value, and a <select> whose bound value matches no option falls back to
// displaying its FIRST option - so the box read "United States" while the model
// held "US", or held null and failed `required` with the box still reading
// "United States". Fold the unambiguous spellings onto the option value so the
// control shows what is actually bound.
//
// Deliberately conservative. Two-letter codes other than "US" are left alone
// because state abbreviations are misfiled in this column ("MA", "CT", "NC"),
// and "CA" would be Canada or California with no way to tell. Anything not
// recognized is returned unchanged, so it shows the placeholder rather than a
// country nobody chose.
const COUNTRY_ALIASES = {
  us: "United States",
  usa: "United States",
  unitedstates: "United States",
  unitedstatesofamerica: "United States",
  estadosunidos: "United States",
  canada: "Canada",
  // Puerto Rico is a state in this app, not a country: stateOptions lists it
  // and STATES_BY_COUNTRY files it under United States, which is also how
  // 7,758 accounts already record it (country United States, state PR). All
  // 302 accounts holding it as a country already carry state PR too, so
  // folding the country loses nothing.
  pr: "United States",
  puertorico: "United States",
};

export function canonicalCountry(value) {
  if (value === null || value === undefined) return value;
  const key = String(value)
    .toLowerCase()
    .replace(/[^a-z]/g, "");
  if (!key) return value;
  return COUNTRY_ALIASES[key] || value;
}
